var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';
import NavParent from './nav-parent';
import { get } from '../utils/funcs';
var List = styled.ul(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  border-bottom: ", ";\n  border-top: ", ";\n  height: ", ";\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  transition: height 250ms ease-out;\n\n  li > a,\n  li > .nav-parent {\n    font-size: 0.95em;\n    padding-left: 4em;\n    &:hover:not(.active) {\n      background-color: ", ";\n    }\n    &:active:not(.active) {\n      background-color: ", ";\n    }\n  }\n  li li > a {\n    padding-left: 5em;\n    &:hover:not(.active) {\n      background-color: ", ";\n    }\n    &:active:not(.active) {\n      background-color: ", ";\n    }\n  }\n\n  &.alwaysShadow {\n    box-shadow: ", ";\n  }\n"], ["\n  background-color: ", ";\n  border-bottom: ", ";\n  border-top: ", ";\n  height: ", ";\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  overflow: hidden;\n  transition: height 250ms ease-out;\n\n  li > a,\n  li > .nav-parent {\n    font-size: 0.95em;\n    padding-left: 4em;\n    &:hover:not(.active) {\n      background-color: ", ";\n    }\n    &:active:not(.active) {\n      background-color: ", ";\n    }\n  }\n  li li > a {\n    padding-left: 5em;\n    &:hover:not(.active) {\n      background-color: ", ";\n    }\n    &:active:not(.active) {\n      background-color: ", ";\n    }\n  }\n\n  &.alwaysShadow {\n    box-shadow: ", ";\n  }\n"])), function (p) {
  return p.theme.level1;
}, function (p) {
  return p.height > 0 ? p.theme.borderWidth + ' solid ' + p.theme.level1 : 0;
}, function (p) {
  return p.height > 0 ? p.theme.borderWidth + ' solid ' + p.theme.level1 : 0;
}, function (p) {
  return p.height + 'px';
}, function (p) {
  return p.theme.level0;
}, function (p) {
  return p.theme.level0;
}, function (p) {
  return p.theme.level1;
}, function (p) {
  return p.theme.level1;
}, function (p) {
  return p.theme.boxShadow;
});

var NavList = function NavList(_a) {
  var children = _a.children,
      _b = _a.icon,
      icon = _b === void 0 ? undefined : _b,
      location = _a.location,
      _c = _a.path,
      path = _c === void 0 ? '' : _c,
      title = _a.title,
      _d = _a.startClosed,
      startClosed = _d === void 0 ? false : _d,
      _e = _a.alwaysShadow,
      alwaysShadow = _e === void 0 ? false : _e;
  var listRef = useRef(null);

  var _f = useState({
    isOpen: false,
    height: 0
  }),
      state = _f[0],
      setState = _f[1];

  useEffect(function () {
    var isOpen = location.pathname.includes(path);
    setState({
      isOpen: isOpen && !startClosed,
      height: isOpen && !startClosed && get(listRef, 'current.scrollHeight') || 0
    });
  }, [listRef, location, path, startClosed, setState]);
  return React.createElement("li", {
    className: "nav-item"
  }, React.createElement(NavParent, {
    onClick: function onClick() {
      return setState({
        isOpen: !state.isOpen,
        height: state.isOpen ? 0 : get(listRef, 'current.scrollHeight', 0)
      });
    },
    path: path,
    title: title,
    icon: icon,
    isOpen: state.isOpen,
    alwaysShadow: alwaysShadow
  }), React.createElement(List, {
    ref: listRef,
    isOpen: state.isOpen,
    height: state.height,
    className: "nav-list" + (state.isOpen ? ' isOpen' : ' closed') + (alwaysShadow ? ' alwaysShadow' : '')
  }, children));
};

export default withRouter(NavList);
var templateObject_1;